import { t } from 'i18next';
import { useMemo } from 'react';

import { CSVEntityImportAction } from '~components/CSVImportExport/CSVEntityImportAction';
import { FeatureFlags } from '~constants/featureFlags';
import { createProjectsConfig } from '~hooks/useCSVImportExport/configs/projectsConfig';
import { useStores } from '~store';

interface ProjectImportActionProps {
  onImportComplete: () => void;
}

export const ProjectImportAction = ({ onImportComplete }: ProjectImportActionProps) => {
  const { userStore } = useStores();
  const userPermissions = userStore.getPermissions();

  const projectsImportConfig = useMemo(() => createProjectsConfig(), []);

  return (
    <CSVEntityImportAction
      canCreateImportedEntity={userPermissions.canCreateImportedProject}
      config={projectsImportConfig}
      entityDisplayName={t('page_headings.projects')}
      featureFlagKey={FeatureFlags.csvProjectImport}
      onImportComplete={onImportComplete}
    />
  );
};
